import { render, staticRenderFns } from "./preferred-delivery-methods.vue?vue&type=template&id=31163ac4&"
import script from "./preferred-delivery-methods.vue?vue&type=script&lang=js&"
export * from "./preferred-delivery-methods.vue?vue&type=script&lang=js&"
import style0 from "./preferred-delivery-methods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports